import {
  INITIATE_MEDIA_UPLOAD, INVALIDATE_UPLOAD_ERROR, UPDATE_MEDIA_UPLOAD_PROGRESS, UPLOAD_MEDIA_REQUEST, UPLOADING_MEDIA_SUCCEEDED, UPLOADING_MEDIA_FAILED,
  DELETE_MEDIA_REQUEST, DELETING_MEDIA_SUCCEEDED, DELETING_MEDIA_FAILED,
  SEARCH_MEDIA_REQUEST, SEARCHING_MEDIA_SUCCEEDED, SEARCHING_MEDIA_FAILED,
  FETCHING_EXTERNAL_LIBRARY, FETCHING_EXTERNAL_LIBRARY_SUCCEDED, FETCHING_EXTERNAL_LIBRARY_FAILED, INVALIDATE_EXTERNAL_LIBRARY,
  INVALIDATE_MEDIA_LIBRARY, INVALIDATE_MEDIA_DELETE_ERROR,
  EDIT_IMAGE_REQUEST, EDITING_IMAGE_SUCCEEDED, EDITING_IMAGE_FAILED
} from 'constants/actionTypes';

import _ from 'lodash';

const initialState = {
  loading: false,
  fetched: false,
  invalidated: false,
  errorType: null,
  items: [],
  pagination: {
    currentPage: 0,
    totalPages: 0,
  },
  uploads: [],
  externalMedia: {
    loading: false,
    loadMore: true,
    selected: [],
    items: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
    }
  }
}

export function mediaReducer(state = initialState, action) {
  switch (action.type) {

    case INITIATE_MEDIA_UPLOAD: {
      const {request, mediaTarget, mediaPaste} = action.payload;
      const {type,size} = request;
      const formats = ['image/jpg', 'image/jpeg', 'image/png', 'image/svg', 'image/bmp', 'image/gif', 'image/svg+xml', 'video/mp4']
      if(type==='video/mp4' && size > 15) {
        return {
          ...state,
          uploadError:true,
          errorType: 'The video size should be less than 15mb.',
          mediaTarget: mediaTarget,
          externalMedia: {
            ...state.externalMedia,
            uploadError:true,
            processing: true
          },
        };
      }
      if(!formats.includes(type)) {
        return {
          ...state,
          uploadError:true,
          errorType: 'Unsupported file format.',
          mediaTarget: mediaTarget,
          externalMedia: {
            ...state.externalMedia,
            uploadError:true,
            processing: true,
            uploadError:true,
            processing: true
          },
        };
      }
      var uploads = [...state.uploads, {...request, mediaPaste: mediaPaste}];
      uploads = _.uniqBy(uploads, 'id');

      return {
        ...state,
        uploads: uploads,
        mediaPaste: mediaPaste,
        mediaTarget:mediaTarget,
        externalMedia: {
          ...state.externalMedia,
          loading: true
        },
      }
    }

    case INVALIDATE_UPLOAD_ERROR: {
      return {
        ...state,
        uploadError: false,
        externalMedia: {
          ...state.externalMedia,
          uploadError: false,
          processing: false
        },
      }
    }

    case UPDATE_MEDIA_UPLOAD_PROGRESS: {
      const { id, progress } = action.payload;

      var uploads = state.uploads.map(media => {
        if (media.id === id) {
          return {
            ...media,
            progress: progress,
            externalMedia: {
              ...media.externalMedia,
              uploadError: true
            },
          }
        }

        return media;
      })

      return {
        ...state,
        uploads: uploads
      }
    }

    case UPLOAD_MEDIA_REQUEST: {
      const { id } = action.payload;

      var uploads = state.uploads.map(media => {
        if (media.id === id) {
          return {
            ...media,
            processing: true
          }
        }
        return media;
      })

      return {
        ...state,
        uploads: uploads,
        externalMedia: {
          ...state.externalMedia,
          processing: true
        },
      }
    }

    case UPLOADING_MEDIA_SUCCEEDED: {
      const { id, response } = action.payload;

      var uploads = state.uploads.filter(media => {
        return media.id != id;
      });

      var items = [response, ...state.items];
      items = _.uniqBy(items, 'id');
      items = _.orderBy(items, 'createdDate', 'desc');

      return {
        ...state,
        uploads: uploads,
        items,
        externalMedia: {
          ...state.externalMedia,
          processing: false
        },
      }
    }

    case UPLOADING_MEDIA_FAILED: {
      const { id, error } = action.payload;

      var uploads = state.uploads.map(media => {
        if (media.id === id) {
          return {
            ...media,
            processing: false,
            error: error
          }
        }

        return media;
      })

      return {
        ...state,
        uploads: uploads,
      }
    } 

    case FETCHING_EXTERNAL_LIBRARY: {
      const request = action.payload;
      let loadMore = initialState.externalMedia.loadMore;
      
      if(request.page == 0) {
        return {
          ...state,
          externalMedia: {
            ...state.externalMedia,
            items: [],
            loading: true,
            loadMore: loadMore
          }
        }
      }

      return {
        ...state,
        externalMedia: {
          ...state.externalMedia,
          loading: true,
          loaded: false,
          loadMore: loadMore
        }
      }
    }

    case FETCHING_EXTERNAL_LIBRARY_SUCCEDED: {

      var items = state.externalMedia.items;
      var { currentPage, totalPages, records = [] } = action.payload.response;
      let loadMore = state.externalMedia.loadMore;

      if (currentPage !== 0) {
        items = [...state.externalMedia.items, ...records];
        if(records.length === 0) {
          loadMore = false;
        }
      } else {
        items = records;
      }

      items = _.uniqBy(items, 'imageUrl');

      return {
        ...state,
        externalMedia: {
          ...state.externalMedia,
          loading: false,
          loaded: true,
          loadMore: loadMore,
          items: items,
          pagination: {
            ...state.externalMedia.pagination,
            currentPage: currentPage,
            totalPages: totalPages,
            totalRecords: records.length
          }
        }
      }
    }

    case FETCHING_EXTERNAL_LIBRARY_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        externalMedia: {
          ...state.externalMedia,
          loading: false,
          loaded: false,
          error: error,
        }
      }
    }

    case INVALIDATE_EXTERNAL_LIBRARY: {
      return {
        ...state,
        externalMedia: {
          ...state.externalMedia,
          items: []
        }
      }
    }

    case SEARCH_MEDIA_REQUEST: {
      return {
        ...state,
          loading: true
        }
      }

    case SEARCHING_MEDIA_SUCCEEDED: {
      const { records, ...pagination } = action.payload.response;
      
      if (pagination.currentPage !== 0) {
        items = [...state.items, ...records];
      } else {
        items = records;
      }
      
      items = _.uniqBy(items, 'id');
      
      return {
        ...state,
        loading: false,
        fetched: true,
        items: items,
        pagination: pagination
      }
    }

    case SEARCHING_MEDIA_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }

    case DELETE_MEDIA_REQUEST: {
      return {
        ...state,
        deleting: true
      }
    }

    case DELETING_MEDIA_SUCCEEDED: {
      const { id, response } = action.payload;
      
      const items = state.items.filter(item => {
        return id != item.id
      });

      return {
        ...state,
        loading: false,
        deleting: false,
        items: items
      }
    }

    case DELETING_MEDIA_FAILED: {
      return {
        ...state,
        loading: false,
        deleting: false,
        error: action.payload.error[0]
      }
    }

    case INVALIDATE_MEDIA_LIBRARY: {
      return initialState;
    }

    case INVALIDATE_MEDIA_DELETE_ERROR:{
      return{
        ...state,
        error:false
      }
    }

    case EDIT_IMAGE_REQUEST: {
      return {
        ...state,
        editingImage: true,
        editImageError: null
      }
    }

    case EDITING_IMAGE_SUCCEEDED: {
      return {
        ...state,
        editingImage: false,
        editImageError: null
      }
    }

    case EDITING_IMAGE_FAILED: {
      return {
        ...state,
        editingImage: false,
        editImageError: action.payload.error
      }
    }

    default:
      return state;
  }
}